import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

import useDebounce from '../../../hooks/useDebounce';

const SearchBox = ({ currentRefinement, refine, className, placeholder }) => {
  const [query, setQuery] = React.useState(currentRefinement);
  const debouncedQuery = useDebounce(query, 200);
  React.useEffect(() => {
    refine(debouncedQuery)
  }, [debouncedQuery]);
  const classes = useStyles();
  const resetQuery = () => {
    setQuery('');
  };
  return (
    <TextField
      className={className}
      value={query}
      onChange={event => setQuery(event.target.value)}
      fullWidth
      InputProps={{
        endAdornment: currentRefinement ? (
          <InputAdornment position='end'>
            <IconButton onClick={resetQuery} edge='end'>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ) : undefined,
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon className={classes.searchIcon} />
          </InputAdornment>
        )
      }}
      placeholder={placeholder}
      variant='outlined'
    />
  );
};

const useStyles = makeStyles(theme => ({
  searchIcon: {
    color: theme.palette.text.secondary
  }
}));

export default connectSearchBox(SearchBox);